import React, { PureComponent } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import styled from 'styled-components';
import './UpdateSubscription.scss';
import SubscriptionPlans from '../Billsby/SubscriptionPlan';
import theme from './theme';


class UpdateSubscription extends PureComponent {
  static propTypes = {
    auth: PropTypes.shape({
      subscriptionLevel: PropTypes.string,
    }).isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      cageCode: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      cntry: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      websiteUrl: PropTypes.string,
    }).isRequired,
  };

  render() {
    const { auth, initialValues } = this.props;


    return (
      <UpdateSubscriptionWrapper>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Update Subscription Page</title>
        </Helmet>
        <StyledContainer>
          <SubscriptionPlans
            auth={auth}
            companyInfo={initialValues}
          />
        </StyledContainer>
      </UpdateSubscriptionWrapper>
    );
  }
}

// Styled components for the UpdateSubscription component using the new color scheme
const UpdateSubscriptionWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  background: #f8f9fa;
  min-height: 100vh;
  
  button {
    background-color: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: white;
    &:hover {
      background-color: ${theme.colors.accent};
      border-color: ${theme.colors.accent};
    }
  }
  
  /* Specific override for Cancel Subscription button */
  .cancel-subscription-btn {
    background-color: #ef4136 !important;
    border-color: #ef4136 !important;
    &:hover {
      background-color:rgb(191, 5, 5) !important;
      border-color:rgb(191, 5, 5) !important;
    }
  }
  
  /* Specific override for Update Card button */
  .update-card-btn {
    background-color: ${theme.colors.primary} !important;
    border-color: ${theme.colors.primary} !important;
    &:hover {
      background-color:rgb(239, 119, 21) !important;
      border-color:rgb(239, 119, 21) !important;  
    }
  }
  
  a {
    color: ${theme.colors.primary};
    &:hover {
      color: ${theme.colors.accent};
    }
  }
  
  /* Additional styling for input elements */
  input, select, textarea {
    border-color: ${theme.colors.gray};
    &:focus {
      border-color: ${theme.colors.primary};
    }
  }
`;


const StyledContainer = styled(Container)`
  padding: 24px;
  background-color: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
  margin-bottom: 20px;
`;

export default UpdateSubscription;



// WEBPACK FOOTER //
// ./src/components/UpdateSubscription/UpdateSubscription.jsx